import React, { useState, useEffect } from 'react';

import { Dropdown, FormCheckbox } from "components";

import { getObjectPropertyValue, getObjectPropertyValueNotNullUndefined, isBooleanFalseNotNullUndefined, isBooleanTrueNotNullUndefined, isNotNullUndefined, isStringEqual_caseInsensitive, isStringTrimEmpty, isStringTrimNotEmpty } from "functions";

export function useSideInputDisplay(props) {
    // Props

    const { 
        isEditing,
        billingSetup,
        referenceValue,
        chargeMethod,

        isFormSubmissionAttempted,
    } = props;

    let isDefaultProduct_init = getObjectPropertyValue(billingSetup, "IsDefaultProduct", false);
    let isAdvancePay_init = getObjectPropertyValueNotNullUndefined(billingSetup, "IsAdvancePay", false);
    let isBillInForeignCurrency_init = getObjectPropertyValueNotNullUndefined(billingSetup, "IsBillInForeignCurrency", false);
    let isSuspense_init = getObjectPropertyValue(billingSetup, "IsSuspense", false);
    let isDraft_init = getObjectPropertyValue(billingSetup, "IsDraft", false); // Default to true for new accounts

    // States
    const [isDefaultProduct, setIsDefaultProduct] = useState(isDefaultProduct_init);
    const [isDefaultProductDisabled, setIsDefaultProductDisabled] = useState(billingSetup?.ChargeMethod === "System");
    const [isAdvancePay, setIsAdvancePay] = useState(isAdvancePay_init);
    const [isBillInForeignCurrency, setIsBillInForeignCurrency] = useState(isBillInForeignCurrency_init);
    const [isSuspense, setIsSuspense] = useState(isSuspense_init);
    const [isDraft, setIsDraft] = useState(isDraft_init);
    const [isAnyInputChanged, setIsAnyInputChanged] = useState(false);

    // Check for changes in input from initial
    useEffect(() => {
        let isNotChangedFromOriginal = (
            isDefaultProduct === isDefaultProduct_init &&
            isAdvancePay === isAdvancePay_init &&
            isBillInForeignCurrency === isBillInForeignCurrency_init &&
            isSuspense === isSuspense_init &&
            isDraft === isDraft_init
        );

        let isChangedFromEmpty = (
            isDefaultProduct || isAdvancePay || isBillInForeignCurrency || isSuspense
        );

        setIsAnyInputChanged(isEditing? !isNotChangedFromOriginal: isChangedFromEmpty);
    }, [
        isDefaultProduct, isAdvancePay, isBillInForeignCurrency, isSuspense, isDraft
    ]);

    let isDefaultProductError = ((isDefaultProduct && isStringTrimNotEmpty(referenceValue)) ||
        (!isDefaultProduct && isStringTrimEmpty(referenceValue)) ||
        (isStringEqual_caseInsensitive(chargeMethod, "System") && isDefaultProduct));
    
    // Display
    let display = (
        <div className={"right-section__side-inputs"}>
            {/* Is Default Product */}
            <div className={"side-inputs__is-default-product " +
                    (isDefaultProductError && isFormSubmissionAttempted? "side-inputs__is-default-product_error ":"")}
            >
                <FormCheckbox
                    checkboxClassName={"is-default-product__checkbox"}
                    checkboxIconClassName={"checkbox__icon"}
                    handleCheckboxSelectionSub={(checkboxId, isChecked) => {
                        setIsDefaultProduct(isChecked);
                    }}
                    isCheckboxCheckedDefault={isDefaultProduct}
                    isCheckboxDisabled={isDefaultProductDisabled}

                    checkboxWrapperClassName={"d-flex justify-content-between"}
                    checkboxLabel={"Set as default product"}
                    isLabelOnLeftSide

                    isFormSubmissionAttempted={isFormSubmissionAttempted}
                    isErrorRequired={isDefaultProductError}
                    errorMsg={
                        (isDefaultProduct && isStringTrimNotEmpty(referenceValue))? "Default product cannot have reference value":
                            (!isDefaultProduct && isStringTrimEmpty(referenceValue))? "Non-default product must have reference value":
                                (isStringEqual_caseInsensitive(chargeMethod, "System") && isDefaultProduct)? "Default product cannot have 'System' as charge method":""}
                />
            </div>

            {/* Advance Pay */}
            <div className={"side-inputs__advance-pay d-flex align-items-center justify-content-between"}>
                {/* Label */}
                <div className={"advance-pay__label"}>
                    Advance Pay
                </div>
                
                <FormCheckbox
                    checkboxClassName={"advance-pay__checkbox"}
                    checkboxIconClassName={"checkbox__icon"}
                    handleCheckboxSelectionSub={(checkboxId, isChecked) => {
                        setIsAdvancePay(isChecked);
                    }}
                    isCheckboxCheckedDefault={isAdvancePay}
                    isFormSubmissionAttempted={isFormSubmissionAttempted}
                    isCheckboxDisabled={isEditing && !isDraft_init}
                />
            </div>

            {/* Bill In Foreign Currency */}
            <div className={"side-inputs__is-bill-foreign-currency d-flex align-items-center justify-content-between"}>
                {/* Label */}
                <div className={"is-bill-foreign-currency__label"}>
                    Bill In Foreign Currency
                </div>
                
                <FormCheckbox
                    checkboxClassName={"is-bill-foreign-currency__checkbox"}
                    checkboxIconClassName={"checkbox__icon"}
                    handleCheckboxSelectionSub={(checkboxId, isChecked) => {
                        setIsBillInForeignCurrency(isChecked);
                    }}
                    isCheckboxCheckedDefault={isBillInForeignCurrency}
                    isFormSubmissionAttempted={isFormSubmissionAttempted}
                    isCheckboxDisabled={isEditing && !isDraft_init}
                />
            </div>

            {/* Is Suspense */}
            {/* <div className={"side-inputs__is-suspense d-flex align-items-center justify-content-between"}>
                <div className={"is-suspense__label"}>
                    Suspense
                </div>
                
                <FormCheckbox
                    checkboxClassName={"is-suspense__checkbox"}
                    checkboxIconClassName={"checkbox__icon"}
                    handleCheckboxSelectionSub={(checkboxId, isChecked) => {
                        setIsSuspense(isChecked);
                    }}
                    isCheckboxCheckedDefault={isSuspense}
                    isFormSubmissionAttempted={isFormSubmissionAttempted}
                    isCheckboxDisabled={isEditing}
                />
            </div> */}

            {/* Draft Status */}
            <div className={"side-inputs__is-draft d-flex align-items-center justify-content-between"}>
                {/* Label */}
                <div className={"is-draft__label"}>
                    Draft Status
                </div>
                
                <FormCheckbox
                    checkboxClassName={"is-draft__checkbox"}
                    checkboxIconClassName={"checkbox__icon"}
                    handleCheckboxSelectionSub={(checkboxId, isChecked) => {
                        setIsDraft(isChecked);
                    }}
                    isCheckboxCheckedDefault={isDraft}
                    isFormSubmissionAttempted={isFormSubmissionAttempted}
                    isCheckboxDisabled={isEditing && !isDraft_init} // Disabled in edit mode when already false (production)
                />
            </div>
        </div>
    );

    let isEveryInputValid = (
        ((isBooleanTrueNotNullUndefined(isDefaultProduct) && isStringTrimEmpty(referenceValue)) ||
            (isBooleanFalseNotNullUndefined(isDefaultProduct) && isStringTrimNotEmpty(referenceValue))) &&
        isNotNullUndefined(isBillInForeignCurrency) &&
        isNotNullUndefined(isSuspense)
    );

    let sideDetails = {
        IsDefaultProduct: isDefaultProduct,
        IsAdvancePay: isAdvancePay,
        IsBillInForeignCurrency: isBillInForeignCurrency,
        IsSuspense: isSuspense,
        IsDraft: isDraft,
    }

    return {
        sideDetails,
        isEveryInputValid,
        isAnyInputChanged,

        isDefaultProduct, setIsDefaultProduct,
        setIsDefaultProductDisabled,
        isDraft, // Return isDraft state to pass to other hooks

        display
    }
}